export default function (size, units = 'B', base = 1024, decimalPlaces = 2) {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(base));

  return `${(size / base ** i).toFixed(decimalPlaces)} ${['', 'k', 'M', 'G', 'T'][i]}${units}`;
}
